var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[[_c('router-view',{key:_vm.key})],_c('template',{slot:"bottom"},[_c('BottomMenu')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }